/**
 * Anonymise une position GPS en arrondissant les coordonnées
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {number} precision - Nombre de décimales (2 = ~1.1km, 3 = ~110m)
 * @returns {{lat: number, lng: number}} Position anonymisée
 */
export const anonymizePosition = (lat, lng, precision = 2) => {
  const factor = Math.pow(10, precision);
  return {
    lat: Math.round(lat * factor) / factor,
    lng: Math.round(lng * factor) / factor
  };
};
